import { getFirstDayOfWeek } from "../utils/dateUtils";
export function getDateRangeFromPreset(preset) {
    if (!preset) {
        return null;
    }
    var today = new Date();
    var startDate;
    var endDate;
    var dayMultiplier = 1000 * 3600 * 24;
    switch (preset.type) {
        case DateRangeType.DAY:
            startDate = new Date(today.getTime() + (preset.offset * dayMultiplier));
            endDate = new Date(startDate.getTime() + (preset.amount * dayMultiplier) - dayMultiplier);
            break;
        case DateRangeType.WEEK:
            startDate = new Date(getFirstDayOfWeek(today).getTime() + (preset.offset * 7 * dayMultiplier));
            endDate = new Date(startDate.getTime() + (preset.amount * 7 * dayMultiplier) - dayMultiplier);
            break;
        case DateRangeType.MONTH:
            startDate = new Date(today.getFullYear(), today.getMonth() + preset.offset, 1);
            endDate = new Date(startDate.getFullYear(), startDate.getMonth() + preset.amount, 0);
            break;
        case DateRangeType.YEAR:
            startDate = new Date(today.getFullYear() + preset.offset, 0, 1);
            endDate = new Date(startDate.getFullYear() + preset.amount, startDate.getMonth(), 0);
            break;
        case DateRangeType.YEAR:
            startDate = new Date(today.getFullYear() + preset.offset, 0, 1);
            endDate = new Date(startDate.getFullYear() + preset.amount, startDate.getMonth(), 0);
            break;
    }
    return [startDate, endDate];
}
export var DateRangeType;
(function (DateRangeType) {
    DateRangeType[DateRangeType["DAY"] = 0] = "DAY";
    DateRangeType[DateRangeType["WEEK"] = 1] = "WEEK";
    DateRangeType[DateRangeType["MONTH"] = 2] = "MONTH";
    DateRangeType[DateRangeType["YEAR"] = 3] = "YEAR";
})(DateRangeType || (DateRangeType = {}));
var DateRangePreset = {
    WEEK_CURRENT: { type: DateRangeType.WEEK, offset: 0, amount: 1, labelId: 'daterange.preset.week.current' },
    WEEK_PREVIOUS: { type: DateRangeType.WEEK, offset: -1, amount: 1, labelId: 'daterange.preset.week.previous' },
    MONTH_CURRENT: { type: DateRangeType.MONTH, offset: 0, amount: 1, labelId: 'daterange.preset.month.current' },
    MONTH_PREVIOUS: { type: DateRangeType.MONTH, offset: -1, amount: 1, labelId: 'daterange.preset.month.previous' },
    DAYS_30: { type: DateRangeType.DAY, offset: -30, amount: 30, labelId: 'daterange.preset.days.30' },
    DAYS_60: { type: DateRangeType.DAY, offset: -60, amount: 60, labelId: 'daterange.preset.days.60' },
    DAYS_90: { type: DateRangeType.DAY, offset: -90, amount: 90, labelId: 'daterange.preset.days.90' },
    YEAR_CURRENT: { type: DateRangeType.YEAR, offset: 0, amount: 1, labelId: 'daterange.preset.year.current' },
    YEAR_PREVIOUS: { type: DateRangeType.YEAR, offset: -1, amount: 1, labelId: 'daterange.preset.year.previous' },
};
export default DateRangePreset;
